import { Box, Popover } from "@mui/material";
import { InstrumentPicker } from "./instrumentPicker";

/**
 *
 * @param root0
 * @param root0.myInstruments
 * @param root0.autoAdd
 * @param root0.anchorEl
 * @param root0.onClose
 * @param root0.onSelect
 * @param root0.sectionID
 * @param root0.familyID
 * @returns {ReactElement} InstrumentsPopover page
 */
export function InstrumentsPopover({
  myInstruments,
  autoAdd,
  anchorEl,
  onClose,
  onSelect,
  sectionID,
  familyID,
}: {
  myInstruments?: boolean;
  autoAdd?: boolean;
  anchorEl: HTMLAnchorElement | HTMLInputElement;
  onClose: () => void;
  onSelect: (i: number[]) => void;
  sectionID?: number;
  familyID?: number;
}) {
  const handleOnSelect = (instrumentsIds) => {
    onSelect(instrumentsIds);
    onClose();
  };

  return (
    <Popover
      onClose={onClose}
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <Box
        sx={{
          width: 500,
          height: 700,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <InstrumentPicker
          autoAdd={autoAdd}
          myInstruments={myInstruments}
          onSelect={handleOnSelect}
          sectionID={sectionID}
          familyID={familyID}
        />
      </Box>
    </Popover>
  );
}
